import { Injectable } from '@angular/core';

import { Route } from '../models';
import { AppState } from '../app-state';

import { RxDocument } from 'rxdb';
import { TestbedRxdbGraphQlCollectionService } from './testbed-rxdb/testbed-rxdb-graphql-collection.service';
import { TestbedRxdbState } from './testbed-rxdb/testbed-rxdb-state';
import { AuthenticationService } from './authentication.service';
import { routePullQueryBuilder, routeSchema } from '../schema/route-schema';

export type RouteDoc = RxDocument<Route,{}>

@Injectable({ providedIn: 'root' })
export class RouteService extends TestbedRxdbGraphQlCollectionService<Route,RouteDoc>{

    constructor(appState:AppState,dbState:TestbedRxdbState,authService:AuthenticationService) {
        super('route', routeSchema, appState,dbState,authService)
        this.syncConfig = { 
            push: false,
            pull: true,
            intervalMs: this.appState.settings.get('rxdb.collections.route.intervalMs',0),
            retry: true,
            bGraphQL: true,
            query: routePullQueryBuilder(),
            graphQLSubscription: 
            `subscription{
                routeUpdated{
                    routes{
                        id
                    }
                }
            }`
        }
    }

}